import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "data-sources-devices" }
const _hoisted_2 = { class: "data-sources-devices__title" }
const _hoisted_3 = { class: "data-sources-devices__description" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "data-sources_next-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NForm = _resolveComponent("NForm")!
  const _component_NButtonFileSelect = _resolveComponent("NButtonFileSelect")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('ds.stream_url')), 1),
    _createVNode(_component_NForm, { layout: _ctx.layout }, null, 8, ["layout"]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$t('ds.add_cameras_phrase_1')) + " ", 1),
      _createVNode(_component_NButtonFileSelect, {
        type: "link",
        onFiles: _ctx.selectFile,
        accept: ".csv"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ds.upload_csv')), 1)
        ]),
        _: 1
      }, 8, ["onFiles"]),
      _createTextVNode(_toDisplayString(_ctx.$t('ds.add_cameras_phrase_2')), 1),
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('ds.add_cameras_phrase_3')) + " ", 1),
      _hoisted_5,
      _createVNode(_component_NButton, {
        type: "link",
        onClick: _ctx.saveSampleCSV
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ds.download_sample_csv')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_NButton, {
        suffixIcon: "data-sources-next",
        onClick: _ctx.next,
        disabled: _ctx.content === ''
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.ds_next')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}